// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-critical-data-technical-controls.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-critical-data-technical-controls',
  title: 'Apply technical and operational controls for critical and sensitive customer data',
  description:
    'The processing of critical or sensitive customer data must be protected by a combination of: access restriction to authorised personnel only; secure storage systems that minimise the risk of unauthorised access; file-level encryption; and backup arrangements to enable recovery. All four control types must be documented and verified.',
  category: 'assets',
  scfIds: ['SCF-DAT-002', 'SCF-IAM-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Critical data technical controls standard is published',
    },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
